export interface PaginationProps {
  page: number;
  total: number;
  perPage: number;
  loading?: boolean;
  /** Rótulo singular do recurso (ex.: "produto"). Plural = `${label}s`. */
  label: string;
  /** O plural, quando não é `${label}s` (ex.: "questão" → "questões"). */
  pluralLabel?: string;
  onPageChange: (page: number) => void;
}

/**
 * Rodapé de paginação: contagem à esquerda, anterior/próxima à direita. Nasceu
 * nos painéis do catálogo e subiu para o design system no terceiro consumidor
 * (campanhas de garantia).
 */
export function Pagination({
  page,
  total,
  perPage,
  loading,
  label,
  pluralLabel = `${label}s`,
  onPageChange,
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));

  return (
    <div className="flex items-center justify-between">
      {/* Sem particípio ("encontrados") para o rótulo poder ser feminino. */}
      <p className="text-(--color-text-secondary) text-xs">
        {total} {total === 1 ? label : pluralLabel} no total
      </p>

      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page === 1 || loading}
            className="border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) rounded-lg border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40"
          >
            Anterior
          </button>
          <span className="text-(--color-text-secondary) text-xs">
            {page} de {totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page === totalPages || loading}
            className="border-(--color-border) text-(--color-text-secondary) hover:bg-(--color-bg-secondary) rounded-lg border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-40"
          >
            Próxima
          </button>
        </div>
      )}
    </div>
  );
}
